import React, { useEffect, useState } from 'react';

export default function RulesPage() {
  const [rulesText, setRulesText] = useState('');

  const backendBase =
    process.env.REACT_APP_API_BASE_URL ||
    process.env.REACT_APP_API_URL ||
    (window.location.hostname === 'localhost'
      ? 'http://localhost:5001'
      : 'https://pickem-backend-2025.onrender.com');

  useEffect(() => {
    fetch(`${backendBase}/api/rules`, { cache: 'no-store' })
      .then(res => res.json())
      .then(data => {
        // Accept {rulesText}, {content}, or a bare string in "text"
        if (typeof data === 'string') return setRulesText(data || 'No rules found.');
        if (data?.rulesText) return setRulesText(data.rulesText || 'No rules found.');
        if (data?.content) return setRulesText(data.content || 'No rules found.');
        return setRulesText('No rules found.');
      })
      .catch(() => setRulesText('Error loading rules.'));
  }, [backendBase]);

  return (
    <div style={{ padding: 20, maxWidth: 800, margin: '0 auto' }}>
      <h2 style={{ fontSize: 20, fontWeight: 'bold', marginBottom: 12 }}>Rules & Instructions</h2>
      <div style={{ whiteSpace: 'pre-wrap', fontSize: 15, lineHeight: 1.5 }}>
        {rulesText || 'No rules found.'}
      </div>
    </div>
  );
}

